import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { BrowserView, isBrowser, isMobile } from 'react-device-detect';
import Header from './components/layout/Header';
import Main from './components/Main';
import './App.css';
import Service from './components/Services';
import Company from './components/Company';
import Addtions from './components/Additions';
import News from './components/News';
import Partner from './components/Partner';
import Contact from './components/Contact';
import MobilePage from './components/mobile/MobilePage';

const App = () => {

  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    console.log("Path changed to:", location.pathname);
    // 여기서 경로 변경을 감지하여 원하는 동작 수행
  }, [location]);

  return (

    <>
      {isMobile ? (
        <MobilePage />
      ) : 
      
      (
        <div className={`${pathname === '/' ? 'app' : 'appCalc'}`}>
          <Header background={pathname === '/' ? true : false} /> { /* 헤더 */}
          <div className='content'>
            <Routes>
              <Route path='/' element={<Main />}/> {/* 메인 페이지 */}
              <Route path='/company' element={<Company />}/> {/* 회사 소개 페이지 */}
              <Route path='/services' element={<Service />}/> { /* 서비스 페이지 */}
              <Route path='/addtions' element={<Addtions />}/> {/* 부가서비스 페이지 */}
              <Route path='/news' element={<News />}/> { /* 보도자료 페이지 */}
              <Route path='/partner' element={<Partner />}/> {/* 제휴사모집 페이지 */}
              <Route path='/contact' element={<Contact />}/> { /* 문의하기 페이지 */}
            </Routes>
          </div>
        </div>
      )
      }
    </>
  )

}

export default App;
